import { FormControl, MenuItem } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { getPunchlistItemTypes } from '../../fetch';
import { alphaSort } from '../../helpers';
import { IDropdownResponse } from '../../models';
import { SMBSelect } from '../input';

interface IPunchlistTypeDropdownProps {
  value: string | number;
  handleChange: (val: string | number) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  apiParams?: any;
  isRequired?: boolean;
  inputLabel?: string;
}

export const PunchlistTypeDropdown: FC<IPunchlistTypeDropdownProps> = ({
  inputLabel,
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  apiParams
}) => {
  const { isLoading: isLoadingPunchlistTypes, data } = useQuery<IDropdownResponse[], Error>(
    ['getPunchlistItemTypes', apiParams],
    () => getPunchlistItemTypes(),
    {
      onSuccess: d => setOptions?.(d)
    }
  );
  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired}>
      <SMBSelect
        disabled={isDisabled || isLoadingPunchlistTypes}
        label={isLoadingPunchlistTypes ? 'Loading...' : inputLabel ?? 'Type'}
        value={value}
        required={isRequired}
        onChange={({ target: { value } }) => {
          handleChange(value);
        }}
        handleClear={() => handleChange('')}
      >
        {!isLoadingPunchlistTypes &&
          data &&
          alphaSort(data, 'description').map((type, index) => {
            return (
              <MenuItem key={`${index}`} value={type.value}>
                {type.description}
              </MenuItem>
            );
          })}
      </SMBSelect>
    </FormControl>
  );
};
